import React, { useState } from "react";
import Classes from "./styles/style.module.css";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";

const CustomInput = ({
  value,
  handleChange,
  customClassName,
  disabled,
  name,
  placeholder,
  label,
  passInput,
  reference,
  type,
  dark
}) => {
  const [showPass, setShowPass] = useState(false);

  const filterNumericInput = (input) => {
    const convertedInput = input.replace(/[۰-۹]/g, (char) =>
      "۰۱۲۳۴۵۶۷۸۹".indexOf(char)
    );
    return convertedInput.replace(/[^0-9]/g, "");
  };

  const handleInputChange = (e) => {
    let inputValue = e.target.value;
    if (type === "number") {
      inputValue = filterNumericInput(inputValue);
    }
    handleChange(inputValue);
  };

  return (
    <div className="w-100 text-right">
      {label && (
        <label
          htmlFor={name}
          className={`${Classes.label} ${disabled ? Classes.disabled : ""} ${dark ? Classes.darkText : ''}`}
        >
          {label}
        </label>
      )}
      <div className={`${Classes.inputContainer} ${dark? Classes.darkInput:''} ${disabled ? Classes.disabledContainer : ''}`}>
        <input
          className={`${Classes.inputStyle} ${customClassName} }`}
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          id={name}
          onChange={handleInputChange}
          autoComplete="off"
          type={!showPass && passInput ? "password" : "text"}
          name={name}
          ref={reference}
          inputMode={
            type === "number" ? "numeric" : type === "tel" ? "tel" : undefined
          }
        />
        {passInput ? (
          <div
            className={Classes.iconContainer}
            onClick={() => {
              setShowPass((prev) => !prev);
            }}
          >
            {showPass ? <AiFillEyeInvisible /> : <AiFillEye />}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CustomInput;
